var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTier3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.564 1.493a.5.5 0 0 1 .707 0l3.68 3.68h.702a.5.5 0 0 1 .332.874l-4.736 4.21a.5.5 0 0 1-.664 0l-4.736-4.21a.5.5 0 0 1 .332-.873h.703l3.68-3.681zm-3.236 6.74L7.79 18.322a.5.5 0 0 0 .495.428h3.264a.5.5 0 0 0 .494-.428l1.464-10.088-3.242 3.145a.5.5 0 0 1-.696 0L6.328 8.233zm3.943-4.231a.5.5 0 0 0-.707 0L8.33 5.234a.5.5 0 0 0 .077.77l1.232.821a.5.5 0 0 0 .554 0l1.233-.821a.5.5 0 0 0 .076-.77L10.27 4.002z",
  clipRule: "evenodd"
})));
export default SvgTier3;